export { default as ProjectionTable } from './ProjectionTable';
export type { Props as ProjectionTableProps } from './ProjectionTable';
